import * as React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function PartnerAbschluss() {
  return <section data-section-id="155087" id="footer" className="bg-[#141414] text-white ![padding:80px_0px_40px_0px]">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    {/* Top: Logo + Nav */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
      <div>
        <Link to="/" className="inline-block mb-8">
          <img src="https://perfect-duck.10web.cloud/wp-content/uploads/2026/03/Coworking-Kassel-Logo.png" alt="BLUVIT GmbH" className="h-8 opacity-80 grayscale transition-all duration-500 hover:grayscale-0 hover:opacity-100" />
        </Link>
        <p className="text-base text-white/40 leading-relaxed max-w-md">
          Dein Arbeitsplatz in Lohfelden — mit allem, was du brauchst. Und ohne das, was dich bremst.
        </p>
      </div>
      <div className="flex flex-col items-start lg:items-end gap-4">
        <Link to="mailto:buchung@kassel-coworking.de" className="text-lg font-medium text-white/60 transition-colors duration-300 hover:text-white">
          buchung@kassel-coworking.de
        </Link>
        <Link to="tel:056151090993" className="text-lg font-medium text-white/60 transition-colors duration-300 hover:text-white">
          0561 51090993
        </Link>
        <p className="text-sm text-white/30">
          Am Alten Rathaus 5a, 34253 Lohfelden
        </p>
      </div>
    </div>

    {/* Bottom: Copyright + Legal */}
    <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
      <div className="flex flex-col sm:flex-row items-center gap-2 text-sm text-white/30">
        <p>&copy; {new Date().getFullYear()} BLUVIT GmbH</p>
        <span className="hidden sm:block">·</span>
        <p>8–16:30 und nach Vereinbarung. Coworkingspace für Mieter 24/7 offen</p>
      </div>
      <div className="flex items-center gap-6 text-sm text-white/30">
        <Link to="/impressum" className="hover:text-white transition-colors duration-200">Impressum</Link>
        <Link to="https://bluvit.de/datenschutz/" newTab className="hover:text-white transition-colors duration-200">
          Datenschutz
        </Link>
      </div>
    </div>
  </div>
</section>;
}